var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31118 0C1.94037 0 0 1.94032 0 4.31118V17.6895C0 20.0603 1.94032 22 4.31118 22H17.6895C20.0604 22 22 20.0604 22 17.6895V4.31118C22 1.94037 20.0604 0 17.6895 0H4.31118ZM5.3955 3.63044C6.53226 3.63044 7.23245 4.3767 7.25406 5.35765C7.25406 6.31694 6.53221 7.08417 5.37352 7.08417H5.35219C4.23707 7.08417 3.51632 6.31698 3.51632 5.35765C3.51632 4.37672 4.25888 3.63044 5.39548 3.63044H5.3955ZM15.1915 8.21527C17.3777 8.21527 19.0166 9.64417 19.0166 12.7148V18.4472H15.6942V13.0992C15.6942 11.7552 15.2133 10.8384 14.011 10.8384C13.0931 10.8384 12.546 11.4564 12.3058 12.0533C12.218 12.2669 12.1964 12.5652 12.1964 12.864V18.4472H8.87401C8.87401 18.4472 8.91761 9.38776 8.87401 8.44971H12.1971V9.86546C12.6386 9.18426 13.4284 8.21524 15.1915 8.21524V8.21527ZM3.7123 8.45044H7.03471V18.4473H3.7123V8.45044Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.fa8bfab7a3b2cabe77441a4f85191ec4.svg";
export { ForwardRef as ReactComponent };